import { useIntl } from 'react-intl';
import { useConfigContext, useAppContext } from '@fe-core';

export const useErrorMap = () => {
  const intl = useIntl();
  const { config } = useConfigContext();
  const { isLoading } = useAppContext();

  if (isLoading) {
    return {};
  }
  return {
    UnauthorizedError: {
      config: {
        title: intl.formatMessage({
          id: 'learner.common.error.unauthorized.title',
        }),
        description: intl.formatMessage({
          id: 'learner.common.error.unauthorized.description',
        }),
      },
      action: {
        text: {
          title: intl.formatMessage({
            id: 'learner.common.error.unauthorized.action',
          }),
        },
        event: `${config?.baseUrls.login}?redirect=${encodeURIComponent(
          window.location.href,
        )}`,
      },
    },
  };
};
